import {
  set, observable,
} from 'mobx';

export interface ICreditCard {
  type: string;
  isDefault: string;
  displayCardNumber: string;
  isExpired: boolean;
  expires: string;
  userPaymentMethodId: string;
  imageSrc: string;
  alternateText: string;
}

class CreditCard implements ICreditCard {
  @observable type: string;

  @observable isDefault: string;

  @observable displayCardNumber: string;

  @observable isExpired: boolean;

  @observable expires: string;

  @observable userPaymentMethodId: string;

  @observable imageSrc: string;

  @observable alternateText: string;

  @observable billingAddressId: string;

  static fromJSON(data: ICreditCard): CreditCard {
    const creditCard = new CreditCard();
    set(creditCard, data);

    return creditCard;
  }
}

export default CreditCard;
